import * as angular from 'angular';

import { INgRedux } from '../redux';
import * as fromStore from '../store';

class HttpInterceptor implements angular.IHttpInterceptor {
    constructor(
        private readonly window: angular.IWindowService,
        private readonly ngRedux: INgRedux
    ) {
        this.response = this.response.bind(this);
    }

    response<T>(response: angular.IHttpResponse<T>): angular.IHttpResponse<T> {
        // If success === false log it for visibility
        if (response.data) {
            const data: any = response.data;
            if (data.success === false) {
                console.warn('* Failed response (success = false)');
            }
        }

        // Check if the response is a failure due to a required login and redirect
        if (typeof response.data === 'string' && response.data.indexOf('/Account/Login') >= 0) {
            this.window.location.reload();
        } else {
            // Reset the last activity
            const lastActivityAction: fromStore.ISetLastActivityAction = {
                type: fromStore.SessionActionType.SET_LAST_ACTIVITY,
                lastActivity: new Date()
            };

            this.ngRedux.dispatch(lastActivityAction);
        }

        return response;
    }
}

const HttpInterceptorFactory: angular.IHttpInterceptorFactory = (
    window: angular.IWindowService,
    ngRedux: INgRedux
) => new HttpInterceptor(window, ngRedux);

HttpInterceptorFactory.$inject = ['$window', '$ngRedux'];

export { HttpInterceptorFactory };
